import { Component, OnInit, Inject, Output, EventEmitter, Input } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { ProgressNotesModel } from 'src/app/models/ProgressNotesModel';
import { ProgressNotesService } from 'src/app/services/ProgressNotesService';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';

@Component({
  selector: 'app-progress-note-entry',
  templateUrl: './progress-note-entry.component.html',
  styleUrls: ['./progress-note-entry.component.css']
})
export class ProgressNoteEntryComponent implements OnInit {
  patientname = '';

  patientcode = '' ;
  progdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  OriginalDate  =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  proglocation = '' ;
  prognotes = '' ;
  prognotestext = '';
  userid = '' ;
  username = '' ;
  progtime  = formatDate(new Date(), 'HH:mm', 'en');
  companyList : CompanyModel[]=[];
  userid_8='';
   username_8='';
orignaluserid =''
   ///-------------------------------
   reialuserid='';
   reialusername='';


  @Output() submitClicked = new EventEmitter<any>();

  maxCharsPerLine: number = 60; // Max characters per line

  editorConfigNoToolbar = {
    editable: true,
    spellcheck: true,
    showToolbar: true,  // 🚫 This hides the toolbar
    height: '150px',
    frameElement:true,
    minHeight: '0',
    placeholder: '',
    translate: 'yes',
    defaultParagraphSeparator: '',
    defaultFontName: '',

    toolbarHiddenButtons: []
  };

  constructor(public progressnote:ProgressNotesModel,
      public dialogRef: MatDialogRef<ProgressNoteEntryComponent>,
      public progressnoteService : ProgressNotesService,
      public companyService : CompanyService,
      public storage: LocalStorageService,
      @Inject(MAT_DIALOG_DATA) public data :any,) {
        this.patientcode = data.patientcode;
        this.patientname = data.Patientname;
        this.progdate =   formatDate(data.progdate, 'yyyy-MM-dd', 'en');
        this.OriginalDate =   formatDate(data.progdate, 'yyyy-MM-dd', 'en');
        this.username= data. username;
              this.userid_8 = data.useridid;
              this.userid = data.useridid;
              this.username_8 = data.username;
              //////------------------------------

              this.reialuserid = data.reialuserid;
              this.reialusername = data.reialusername;
              this.orignaluserid = data.useridid;
              this.username = data.username;
              debugger;


      }

  ngOnInit(): void {
    // if (this.storage.retrieve('stgGroup') == '8'){
    //   this.userid = this.storage.retrieve('stgUserIdId')
    // }
    // else
    // {
    // this.userid = this.storage.retrieve('stgUserId')
    // };
    //this.patientcode = this.storage.retrieve('stgPatientCode');
    //this.patientname = this.storage.retrieve('stgPatientName');
    // this.progdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    // this.OriginalDate = formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');

    this.retriveCompanyLookupTop();
    this.proglocation = this.storage.retrieve('stgLocation');
    this.RetriveData();

  }
  RetriveData(){
      this.progressnoteService.getProgressNotes(this.patientcode, this.progdate,this.userid).subscribe({
      next: (data: ProgressNotesModel) => {
        this.proglocation = data.proglocation;
        this.progdate =formatDate(data.progdate, 'yyyy-MM-dd', 'en');
        this.prognotes = data.prognotes;
        this.userid = data.userid;
        this.progtime = formatDate(data.progtime, 'hh:mm aa', 'en');
      },
      error: (error) => {
        // Handle any actual errors here, if needed.  For example:
        console.error("Error fetching nurse assessment:", error);
        // You might also want to display an error message to the user.
      },
      complete: () => {
        // This block executes after a successful completion (even if data is null/undefined).
          if (!this.proglocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.proglocation = this.storage.retrieve('stgLocation');
              this.progdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');

          }
      }
    });
  }
  updatePlainText() {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = this.prognotes || '';
    this.prognotestext = tempElement.textContent || '';
  }
  retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {

        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
  Save_Data(){
    debugger;
    this.progtime  =formatDate(new Date(), 'HH:mm', 'en');
         const str1 = formatDate(this.progdate,'yyy-MM-dd','en') + 'T' + this.progtime + ':00.000Z';


    this.progressnote.patientcode= this.patientcode;
    this.progressnote.progdate= this.progdate;
    if(this.proglocation === undefined || this.proglocation === null || this.proglocation.trim() === '') {
      this.proglocation = this.storage.retrieve('stgLocation');
    }


    this.progressnote.proglocation= this.proglocation;
    this.progressnote.prognotes= this.prognotes;

   if (this.storage.retrieve('stgGroup') == '8') {

    this.progressnote.userid = this.orignaluserid;
    this.progressnote.username = this.username;
    this.progressnote.progtime = str1 ;
    this.progressnoteService
        .deleteProgressNotes(
            this.progdate,
            this.storage.retrieve('stgPatientCode'),
            this.orignaluserid
        )
        .subscribe(() => {

            this.progressnoteService.AddProgressNotes(this.progressnote)
                .subscribe(() => {
                    this.mesgSave();
                    this.dialogRef.close();
                });

        });

}
else {

    this.progressnote.userid = this.reialuserid;
    this.progressnote.username = this.reialusername;

    this.progressnoteService.AddProgressNotes(this.progressnote)
        .subscribe(() => {
            this.mesgSave();
            this.dialogRef.close();
        });

}
  }
  mesgSave() {
        swal({
        title: 'Your work has been saved',

        type: 'success',
        showConfirmButton: false,

        timer: 1500
        });
  }

  limitLineLength() {
    const lines = this.prognotes.split("\n"); // Respect manual line breaks
    const formattedLines: string[] = [];

    for (let line of lines) {
      while (line.length > this.maxCharsPerLine) {
        let breakpoint = this.maxCharsPerLine;
        // Look for the last space before maxCharsPerLine to avoid breaking a word
        const lastSpace = line.lastIndexOf(" ", this.maxCharsPerLine);
        if (lastSpace > -1) {
          breakpoint = lastSpace;
        }
        // Push line up to the breakpoint
        formattedLines.push(line.substring(0, breakpoint).trim());
        // Trim and keep the rest of the line
         line = line.substring(breakpoint).trim();
      }
      formattedLines.push(line);
    }

    this.prognotes = formattedLines.join("\n");
  }
  Exit_Data(){
      this.dialogRef.close();
    }
}
